import React, { useEffect, useState } from 'react';
import { Button, Modal, Portal } from 'next-common-lib';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ContactProfileCardContent from './ContactProfileCardContent';
import { getContacInfor } from '../../apis/contactAPI';

const ContactProfileCard = props => {
  const { uid, groupID, closeFunction, position, originUser, cUserId } = props;
  const [data, setData] = useState(undefined);
  const { t } = useTranslation('contacts');

  useEffect(() => {
    (async () => {
      try {
        const response = await getContacInfor(uid, groupID, originUser, cUserId);
        if (!response) throw new Error('No data');
        setData(response);
      } catch (e) {
        const errorId = 'error-load-emp';
        const closeMess = () => Portal.close(errorId);

        Portal.open('popup', errorId, {
          size: 'sm',
          titleComponent: [<h1 className="popup-title">Error</h1>],
          messageComponent: [e.message || 'Load data fail'],
          buttonComponent: [
            <Button color="primary" label={t('contacts.searchPeopleContactsTab.text.ok')} onClick={closeMess} />,
          ],
          closeFunction: closeMess,
        });
        closeFunction();
      }
    })();
  }, []);

  return (
    (data && (
      <Modal isShow width="400px" {...position}>
        <ContactProfileCardContent data={data} closeFunction={closeFunction} />
      </Modal>
    )) || <></>
  );
};

ContactProfileCard.propTypes = {
  uid: PropTypes.string.isRequired,
  groupID: PropTypes.string.isRequired,
  closeFunction: PropTypes.func,
  position: PropTypes.object,
  originUser: PropTypes.string,
  cUserId: PropTypes.string,
};

ContactProfileCard.defaultProps = {
  closeFunction: () => {},
  position: {},
  originUser: '',
  cUserId: '',
};

export default ContactProfileCard;
